import { Text, View, Image } from '@react-pdf/renderer';

import NoImage from "../../../../../../Assets/missing_image.jpg";

const cartQtyById = ( cartItems = [] ) => {

    const fromProps = ( cartItems || [] ).reduce ( ( map, item ) => {

        if ( item?.productId != null ) {

            map[ String ( item.productId ) ] = parseInt ( item.productCount, 10 ) || 1;

        }

        return map;

    }, {} );

    if ( Object.keys ( fromProps ).length ) return fromProps;

    try {

        const cart = JSON.parse ( localStorage.getItem ( "cart" ) || "[]" );

        return cart.reduce ( ( map, item ) => {

            map[ String ( item.id ) ] = parseInt ( item.qty, 10 ) || 1;

            return map;

        }, {} );

    } catch {

        return {};

    }

};

export default function DocumentProducts ( { order, products, cartItems } ) {

    const qtyById = cartQtyById ( cartItems ),

        lineItems = ( products || [] ).filter ( ( edge ) => edge?.node );

    return (

        <View>

            <View style={ { flexDirection: "row", flexWrap: "nowrap", borderBottom: "1px solid #999" } }>

                <Text style={ { flex: 0.15, fontWeight: 500 } }>Nr.</Text>

                <Text style={ { flex: 1 } }>Prece</Text>

                <Text style={ { flex: 1, fontWeight: 500 } }>Apraksts</Text>

                <Text style={ { flex: 0.5, fontWeight: 500 } }>Daudzums</Text>

                <Text style={ { flex: 1, fontWeight: 500 } }>Cena</Text>

                <Text style={ { flex: 1, fontWeight: 500 } }>Kopējā cena</Text>

            </View>

            {

                lineItems.map ( ( edge, index ) => {

                    const node = edge.node,

                        productCount = qtyById[ String ( node.id ) ] || 1,

                        unitPrice = Number ( node?.priceList?.retail_price ) || 0,

                        unitPriceExclVat = unitPrice / 1.21,

                        productTypes = {

                            tire: `${ node?.width } x ${ node?.height } x R${ parseInt ( node?.diameter ) }${ node?.isCTire ? "C" : "" } | ${ node?.loadIndex }${ node?.speedRating?.toUpperCase () || "" }`,

                            rim: `${ node?.width || "-" }J | R${ parseInt ( node?.diameter ) || "-" } | ${ node?.pitchCircleDiameter || "-" } | ET${ node?.offset || "-" } | CB${ node?.centreBore || "-" }`,

                            battery: `${ node?.voltage } V | ${ node?.current } A | ${ node?.capacity } Ah`,

                        };

                    return (

                        <View key={ node.id } style={ { flexDirection: "row", flexWrap: "nowrap", borderBottom: "1px solid #999" } }>

                            <View style={ { flex: 0.15, display: "flex", justifyContent: "center" } }>

                                <Text>{ index + 1 }</Text>

                            </View>

                            <View style={ { flex: 0.25, justifyContent: "center", alignItems: "center", padding: 4 } }>

                                <Image
                                    src={ ( typeof node?.currentImage === "string" && node.currentImage.startsWith ( "data:" ) )
                                        ? node.currentImage
                                        : NoImage }
                                    style={ { width: 48, height: 48, objectFit: "contain" } }
                                />

                            </View>

                            <View style={ { flex: 1, display: "flex", justifyContent: "center" } }>

                                <View style={ { display: "block" } }>

                                    <Text>

                                        { [ node?.manufacturer?.name?.toUpperCase (), node?.model ].filter ( Boolean ).join ( " " ) }

                                    </Text>

                                </View>

                                { node?.color &&

                                    <View style={ { display: "block" } }>

                                        <Text>{ node.color }</Text>

                                    </View>

                                }

                                <View style={ { display: "block" } }>

                                    <Text>{ productTypes[ node?.productType ] || "-" }</Text>

                                </View>

                                <View style={ { display: "block" } }>

                                    <Text style={ { color: "#bbb" } }>ID: { node.id }</Text>

                                </View>

                            </View>

                            <View style={ { flex: 0.5, display: "flex", justifyContent: "center" } }>

                                <Text>{ productCount }</Text>

                            </View>

                            <View style={ { flex: 1, display: "flex", justifyContent: "center" } }>

                                <View style={ { display: "block" } }>

                                    <Text>bez PVN: { unitPriceExclVat.toFixed ( 2 ) } EUR</Text>

                                </View>

                                <View style={ { display: "block" } }>

                                    <Text>ar PVN: { unitPrice.toFixed ( 2 ) } EUR</Text>

                                </View>

                            </View>

                            <View style={ { flex: 1, display: "flex", justifyContent: "center" } }>

                                <View style={ { display: "block" } }>

                                    <Text>bez PVN: { ( unitPriceExclVat * productCount ).toFixed ( 2 ) } EUR</Text>

                                </View>

                                <View style={ { display: "block" } }>

                                    <Text>ar PVN: { ( unitPrice * productCount ).toFixed ( 2 ) } EUR</Text>

                                </View>

                            </View>

                        </View>

                    );

                } )

            }

            <View style={ { flexDirection: "row", alignSelf: "flex-end", fontSize: 10 } }>

                <View style={ { width: 50 + "%" } }>

                    <View style={ { flexDirection: "row", borderBottom: "1px solid #999" } }>

                        <Text style={{ flex: 1 }}>Piegāde</Text>

                        <Text style={{ flex: 1 }}>{ Number ( order?.delivery || 0 ).toFixed ( 2 ) } EUR</Text>

                    </View>

                    <View style={ { flexDirection: "row" } }>

                        <Text style={{ flex: 1 }}>Kopsumma bez PVN</Text>

                        <Text style={{ flex: 1 }}>{ Number ( ( order?.totalExeclVat ?? order?.total_execl_vat ) || 0 ).toFixed ( 2 ) } EUR</Text>

                    </View>

                    <View style={ { flexDirection: "row" } }>

                        <Text style={{ flex: 1 }}>PVN</Text>

                        <Text style={{ flex: 1 }}>{ Number ( order?.vat || 0 ).toFixed ( 2 ) } EUR</Text>

                    </View>

                    <View style={ { flexDirection: "row", borderBottom: "1px solid #999", borderTop: "1px solid #999", fontWeight: 500, fontSize: 11 } }>

                        <Text style={{ flex: 1 }}>Kopsumma apmaksai</Text>

                        <Text style={{ flex: 1 }}>{ Number ( order?.total || 0 ).toFixed ( 2 ) } EUR</Text>

                    </View>

                </View>

            </View>

        </View>

    );

};
